import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { FlexRow } from 'components/Flex'
import { DaysOfWeek } from 'lib/daysOfWeek'
import { DaysOfWeekColumn, TimeColumn } from 'components/Card'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getHolidays, getLastOrderTime, getLastPickupTime, getOrderStartTime } from 'reducks/store/selectors'
const daysOfWeek = new DaysOfWeek()

const BusinessHourTable: FC = () => {
  const holidays = useSelector((state: State) => getHolidays(state))
  const lastOrderTime = useSelector((state: State) => getLastOrderTime(state))
  const lastPickupTime = useSelector((state: State) => getLastPickupTime(state))
  const orderStartTime = useSelector((state: State) => getOrderStartTime(state))

  return (
    <FlexRow justifyContent={'between'}>
      <span />
      <DaysOfWeekColumn daysOfWeek={daysOfWeek.getDaysOfWeek()} holidays={holidays} />
      <div className={styles.businessHour__line} />
      <TimeColumn daysOfWeek={daysOfWeek.getDaysOfWeek()} header={'オーダー開始'} businessTime={orderStartTime} />
      <div className={styles.businessHour__line} />
      <TimeColumn daysOfWeek={daysOfWeek.getDaysOfWeek()} header={'ラストオーダー'} businessTime={lastOrderTime} />
      <div className={styles.businessHour__line} />
      <TimeColumn daysOfWeek={daysOfWeek.getDaysOfWeek()} header={'最終受渡'} businessTime={lastPickupTime} />
      <span />
    </FlexRow>
  )
}

export default BusinessHourTable
